import React from "react";
// Common Components
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
// Local Components
import { Additional } from "./Additional";
// Requests
import { getBaseHedgerPairTable } from "src/Requests/automaticMarketMaking";

interface IProps {
  refreshFlag: boolean;
  onFetchComplete: () => void;
}
const BaseHedgerPairTable: React.FC<IProps> = ({
  refreshFlag,
  onFetchComplete,
}) => {
  return (
    <div className="rounded mt-10 flex w-full min-w-0 items-stretch overflow-x-hidden">
      <TableTemplate
        TableUI={({ reports, onAction }) => (
          <CommonTableUI
            reports={reports}
            onAction={onAction}
            refreshFlag={refreshFlag}
            AdditionalBody={Additional}
            tableBoxClassName="!max-h-[800px]"
            withSelect
          />
        )}
        refreshTableTime={30000}
        getDataTable={getBaseHedgerPairTable}
        onFetchComplete={onFetchComplete}
      />
    </div>
  );
};

export default BaseHedgerPairTable;
